function getCleanedString(cadena: string, replace: null | string = null) {
    var specialChars = '!@#$^&%*()+=-[]/{}|:<>?,.'
    for (var i = 0; i < specialChars.length; i++) {
        cadena = cadena.replace(new RegExp('\\' + specialChars[i], 'gi'), '')
    }
    cadena = cadena.toLowerCase()

    if (replace !== null) {
        cadena = cadena.replace(/ /g, replace)
    } else {
        cadena = cadena.replace(/ /g, ' ')
    }

    cadena = cadena.replace(/á/gi, 'a')
    cadena = cadena.replace(/é/gi, 'e')
    cadena = cadena.replace(/í/gi, 'i')
    cadena = cadena.replace(/ó/gi, 'o')
    cadena = cadena.replace(/ú/gi, 'u')
    cadena = cadena.replace(/ñ/gi, 'n')
    return cadena
}

export default getCleanedString
